<template>
<div class="baojia_express" :style="isdetail?'':stylecss">
	<el-card class="box-card">
		<table class="tablecss" cellspacing="0">
			<thead>
				<td class="td6" style="height:32px;">{{baojia_clearance_lang.payitem}}</td>
				<td class="td6">{{baojia_clearance_lang.price}}</td>
				<td class="td6">{{baojia_clearance_lang.unit}}</td>
				<td class="td6">{{baojia_clearance_lang.remark}}</td>
				<td class="td8" v-if="!isdetail"></td>
			</thead>
			<tbody>
				<tr v-for="(item,i) in list" :key="i">
					<td class="td6" style="height:32px;">
						<el-select v-model="item.p_payitem" size="mini" :filterable="true" :clearable="true" style="width:100%;" v-if="!isdetail">
							<el-option v-for="pay in paylist" :key="pay.label" :value="pay.label" :label="pay.label"></el-option>
						</el-select>
						<span v-else>{{item.p_payitem}}</span>
					</td>
					<td class="td6">
						<el-input type="text" size="mini" v-model="item.price" v-if="!isdetail">
						</el-input>
						<span v-else>{{item.price}}</span>
					</td>
					<td class="td6">
						<el-input type="text" size="mini" v-model="item.unit" v-if="!isdetail">
						</el-input>
						<span v-else>{{item.unit}}</span>
					</td>
					<td class="td6">
						<el-input type="text" size="mini" v-model="item.remark" v-if="!isdetail">
						</el-input>
						<span v-else>{{item.remark}}</span>
					</td>
					<td v-if="!isdetail">
						<i class="el-icon-delete" style="color:red" @click="delitem(i)"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<div style="margin-top:5px;margin-left:5px" v-if="!isdetail">
			<el-button size="mini" type="primary" @click="addpayitem">{{baojia_clearance_lang.addpayitem}}</el-button>
		</div>
	</el-card>
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span style="margin-right:28px">{{baojia_clearance_lang.tips}}  </span>
		</div>
		<el-row>
			<el-col :span="24" v-if="!isdetail">
				<div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div>
			</el-col>
			<el-col :span="24" v-else>
				<div v-html="info.remark"></div>
			</el-col>
		</el-row>
	</el-card>
</div>	
</template>

<script>
import E from 'wangeditor';
export default {
	components: {
		
	},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isdetail:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			c_id:'',
			stylecss:{height:`${window.innerHeight - 210}px`, 'overflow-y': 'auto' },
			baojia_clearance_lang:{},
			list:[{p_payitem:'',unit:'',price:'',remark:''}],
			paylist:[],
			info:'',
			editor: {},
			endport:''
		}
	},
	mounted(){
		import('../../static/' + this.$theme + '/style/cw/setbaojia.scss');
	},
	methods:{
		init(param){
			if(param.c_id!=undefined)
				this.c_id=param.c_id;
			if(param.info!=undefined)
				this.info=param.info;
			this.loadlanguage();
			if(!this.isdetail)
				this.loadpayitem();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('baojia_clearance',this).then(res=>{
				if(res.state=='1')
					that.baojia_clearance_lang=that.$lang.label.baojia_clearance;
				that.getInfo();
			});
		},
		loadpayitem(){
			var that=this;
			this.$apipost.get.dic({type:'收费项目'}).then(res=>{
				if(res.list!=undefined){
					that.paylist=res.list;
				}
			});
		},
		addpayitem(){
			var item=JSON.parse(JSON.stringify(this.list[0]));
			item.p_payitem='';
			item.price='';
			item.unit='';
			item.remark='';
			this.list.push(item);
		},
		delitem(index){
			if(this.list.length>0&&index>0)
				this.list.splice(index,1);
		},
		getInfo(){
			var that=this;
			if(this.c_id!=''){
				var paraminfo={
					c_id:this.info.c_id,
					type:this.info.type
				}
				this.$apipost.get.GetSchemeList({paraminfo:paraminfo}).then(res=>{
					//debugger
					if(res.state=='1')
						that.list=res.list;
					else
						this.$tool.message(that.baojia_clearance_lang.getinfofail, 0);
				});
			}
			if(!this.isdetail)
				this.initEditor();
		},
		//初始化富文本框内容
		initEditor() {
			var html='';
			if(this.info!='')
				html=this.info.remark;
			this.editor = new E(this.$refs.editor);
			this.editor.config.height =200;
			this.editor.config.excludeMenus = ['emoticon','image', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.showLinkImg = false;
			this.editor.config.placeholder =this.baojia_clearance_lang.remarkplaceholder;
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		}
	}
}
</script>

<style>
</style>